import { useEffect } from 'react';
import { getEnv } from 'utils';

export default function AuajruolPage() {
  useEffect(() => {
    window.location.href = `${getEnv('MTG_URL_PUBLISHERS')}/journal-of-urology`;
  }, []);
}
